export default "__VITE_ASSET__3604fb01__"